import { CellText } from './cell-text';

export function CellEmail({ className, email }: { email: string | undefined | null; className?: string }) {
  if (!email) {
    return <CellText className={className}>—</CellText>;
  }

  return (
    <a className={`group ${className}`} href={`mailto:${email}`} rel="noreferrer" target="_blank">
      <CellText className="decoration-primary decoration-2 group-hover:underline">{email}</CellText>
    </a>
  );
}
